import { connect } from "react-redux";
import { RootState, TypedDispatch } from "../../../../../redux/store";
import {
  BillingInitialStateDTO,
  CreateBillingDTO,
  UpdateBranchDTO,
  UpdateUserDTO,
} from "../service/types";
import { getStaffList } from "../../ManageStaff/service/Staffslice";
import ManageSubscription from "../components/subscription/ManageSubscription";
import { getBranchList } from "../../ManageBranch/service/Branchslice";
import {
  checkPromocodeByName,
  createBilling,
  getBillingByInstituteId,
  getSubscriptionByInstituteId,
  removeBranchOrBranchLicense,
  removeUserOrUserLicense,
} from "../service/Billingslice";
import { getInstituteById } from "../../InstituteProfile/service/instituteSlice";
import { setActiveInsitute } from "../../../../../service/activeInstituteSlice";

interface DispatchProps {
  GetStaffList(id: string): void;
  GetBranchList(id: string): void;
  GetBillingByInstituteId(id: string, status: string): void;
  GetSubscriptionByInstituteId(id: string): void;
  CreateBilling(data: CreateBillingDTO): void;
  CheckPromocodeByName(name: string): void;
  RemoveUserOrUserLicense(data: UpdateUserDTO): void;
  RemoveBranchOrBranchLicense(data: UpdateBranchDTO): void;
  GetInstituteById(id: string): void;
}

const mapStateToProps = (state: RootState): BillingInitialStateDTO => {
  return {
    error: state.billing.error,
    success: state.billing.success,
    loading: state.billing.loading,
    instituteBillingData: state.billing.instituteBillingData,
    instituteSubscriptionData: state.billing.instituteSubscriptionData,
    promocodeByName: state.billing.promocodeByName,
    billingAdmins: state.billing.billingAdmins,
    billingAddress: state.billing.billingAddress,
    paymentHistory: state.billing.paymentHistory,
    paymentInvoice: state.billing.paymentInvoice,
    billingPaymentLink: state.billing.billingPaymentLink,
    billingAdminError: state.billing.billingAdminError,
    billingAdminSuccess: state.billing.billingAdminSuccess,
    billingAdminLoading: state.billing.billingAdminLoading,
    userRemovalError: state.billing.userRemovalError,
    userRemovalSuccess: state.billing.userRemovalSuccess,
    userRemovalLoading: state.billing.userRemovalLoading,
    branchRemovalError: state.billing.branchRemovalError,
    branchRemovalSuccess: state.billing.branchRemovalSuccess,
    branchRemovalLoading: state.billing.branchRemovalLoading,
    errorBilling: state.billing.errorBilling,
    successBilling: state.billing.successBilling,
    loadingBilling: state.billing.loadingBilling,
    subscriptionStatusError: state.billing.subscriptionStatusError,
    subscriptionStatussuccess: state.billing.subscriptionStatussuccess,
    subscriptionStatusloading: state.billing.subscriptionStatusloading,
    promocodeError: state.billing.promocodeError,
    promocodesuccess: state.billing.promocodesuccess,
    promocodeloading: state.billing.promocodeloading,
    Invoicesuccess: state.billing.Invoicesuccess,
    billingDataLoading: state.billing.billingDataLoading,
    autoDebitError: state.billing.autoDebitError,
    autoDebitSuccess: state.billing.autoDebitSuccess,
    autoDebitLoading: state.billing.autoDebitLoading,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetStaffList: (id: string) => {
      dispatch(getStaffList(id));
    },
    GetBranchList: (id: string) => {
      dispatch(getBranchList(id));
    },
    GetBillingByInstituteId: (id: string, status: string) => {
      dispatch(getBillingByInstituteId({ id: id, status: status }));
    },
    GetSubscriptionByInstituteId: (id: string) => {
      dispatch(getSubscriptionByInstituteId(id));
    },
    CreateBilling: (data: CreateBillingDTO) => {
      dispatch(createBilling(data));
    },
    CheckPromocodeByName: (name: string) => {
      dispatch(checkPromocodeByName(name));
    },
    RemoveUserOrUserLicense: (data: UpdateUserDTO) => {
      dispatch(removeUserOrUserLicense(data));
    },
    RemoveBranchOrBranchLicense: (data: UpdateBranchDTO) => {
      dispatch(removeBranchOrBranchLicense(data));
    },
    GetInstituteById: (id: string) => {
      dispatch(getInstituteById(id));
      dispatch(setActiveInsitute(id));
    },
  };
};

export interface ManageSubscriptionProps
  extends BillingInitialStateDTO,
    DispatchProps {}
export const ManageSubscriptionComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageSubscription);
